import { gsap, Power3 } from "gsap";

export default class Overlays {
  constructor() {
    this.closeOverlayTrigger = document.querySelectorAll(".js-overlay-close");
    this.openOverlayTrigger = document.querySelectorAll(".js-overlay-open");
    this.params = new URLSearchParams(window.location.search);

    this.init();
  }

  init() {
    if (this.params.get('enquiry')) {
      this.handleUrlParams(this.params.get('enquiry'));
    }

    this.openOverlayTrigger.forEach(element => {
      element.addEventListener("click", (e) => {
        e.preventDefault();
        this.openOverlay(element);
        this.toggleForm(element);
      });
      element.addEventListener("keydown", (e) => {
        e.preventDefault();
        if (e.code === "Enter") {
          this.openOverlay(element);
        }
      });
    });

    this.closeOverlayTrigger.forEach(element => {
      element.addEventListener("click", (e) => {
        this.closeOverlay(element);
      });
      element.addEventListener("keydown", (e) => {
        if (e.code === "Enter") {
          this.closeOverlay(element);
        }
      });
    });

  }

  handleUrlParams(param) {
    let button = document.querySelector(`[data-url-form='${param}']`);
    let enquiryForm = document.querySelector(`[data-form="${button.dataset.formToggle}"]`);

    if (enquiryForm && button) {
      this.openOverlay(button);
      this.toggleForm(button);
    }
  }

  openOverlay(trigger) {
    document.body.classList.add('no-scroll');
    let thisOverlay = document.querySelector(`.js-overlay[data-overlay="${trigger.dataset.overlay}"]`);
    let thisCover = thisOverlay.previousElementSibling;
    if (document.querySelector('.js-overlay-active')) {
      this.closeOverlay(document.querySelector('.js-overlay-active .js-overlay-close'));
    }

    let mapEl = thisOverlay.querySelector('[data-map-id]');

    gsap.to(thisOverlay, {
      duration: .3,
      delay: .25,
      top: 0,
      display: 'block',
      ease: Power3.in,
      onStart: () => {
        thisOverlay.querySelectorAll('[data-extra-field]').forEach(element => {
          let thisFieldType = element.dataset.extraField;
          if (trigger.hasAttribute('data-' + thisFieldType)) {
            element.value = trigger.getAttribute('data-' + thisFieldType);
          }
        });
      },
      onComplete: () => {
        thisOverlay.classList.add('js-overlay-active');

        if (mapEl) {
          let mapID = mapEl.dataset.mapId;

          let map = window.MapSVG.getById(mapID);
          map.redraw();
        }
      }
    });

    if (window.matchMedia('(min-width: 1024px)').matches) {
      gsap.to(thisCover, {
        duration: .3,
        delay: .3,
        opacity: 1,
        display: 'block',
        ease: Power3.in
      });
    }
  }

  closeOverlay(trigger) {
    document.body.classList.remove('no-scroll');
    trigger.closest('[data-overlay]').classList.remove('js-overlay-active');
    gsap.to(trigger.closest('[data-overlay]'), {
      duration: .3,
      delay: .25,
      top: '100%',
      display: 'none',
      ease: Power3.in,
      onStart: () => {
        trigger.closest('[data-overlay]').querySelectorAll('[data-extra-field]').forEach(element => {
          element.value = '';
        });
      }
    });

    if (trigger.closest('[data-overlay]').previousElementSibling.style.display == 'block') {
      gsap.to(trigger.closest('[data-overlay]').previousElementSibling, {
        duration: .3,
        delay: .2,
        opacity: 0,
        display: 'none',
        ease: Power3.in
      });
    }
  }

  toggleForm(element) {
    if (element.dataset.formToggle) {
      let enquiryForm = document.querySelector(`[data-form="${element.dataset.formToggle}"]`);
      let formElement = document.querySelector(`[data-form-type="${element.dataset.formToggle}"]`);

      if (enquiryForm) {
        enquiryForm.checked = true;
      }

      document.querySelectorAll(`[data-form-type]`).forEach(element => { element.classList.add("hidden") });
      formElement.classList.remove("hidden");
    }
  }
}
